import LazyLoad from "vanilla-lazyload";
import lazyLoad from "./components/lazyLoad";
document.addEventListener('DOMContentLoaded', function () {

	lazyLoad();

	let myLazyLoad = new LazyLoad();
});

$(document).ready(function() {

	if($('.faq-question').length > 0) {
		$('.faq-question').click(function () {
			$(this).closest('.faq-list__item').toggleClass('active');
			$(this).next('.faq-answer').slideToggle(200);
		});
	}


//------------------------------------------CASINOS SHOW MORE-----------------------------------

	$('#show-casinos').click(function(){
		var This = $(this),
			currentText = This.text(),
			newText = This.attr('data-less');
		This.text(newText);
		This.attr('data-less',currentText);
		$('#casinos-list').toggleClass('active');
	});


//----------------------------------------------SCROLL TOP-----------------------------------

	$(window).scroll(function() {
		var getScrollTopBtn = $(".scroll-top");
		var footer = $(".footer").height();
		var scrollBottom = $(document).height() - $(window).height() - $(window).scrollTop();

		$(this).scrollTop() > 100 ? getScrollTopBtn.fadeIn() : getScrollTopBtn.fadeOut()

		if(scrollBottom < footer) {
			getScrollTopBtn.addClass("sticky");
		}

	});

	$(".scroll-top").click(function() {
		return $("body,html").animate({
			scrollTop: 0
		}, 800)
	});
});



//----------------------------------------------HEADER-----------------------------------

$('.menu-toggle-wrapper').click(function(){
	$(this).find('.menu-toggle-button').toggleClass('active');
	$('.header-menu_wrap').toggleClass('active');
	$('body').toggleClass('overflow');

	if( $('.header-menu_wrap').hasClass('active')){
		$('.login, .signup').appendTo('.header-menu_mobile');
	}else{
		$('.login, .signup').appendTo('.header-user');
	}
});


//----------------------------------------------IFRAME-----------------------------------

$('.button-play-for-free').on('click', function () {
	$iframe_link = $(this).attr('data-iframe-link');
	$('.play-box').addClass('frame-active');
	$(".play-box .iframe").append('<iframe src="'+ $iframe_link +'" frameborder="0" scrolling="no" width="100%" height="100%" frameborder="0" margin="0" allowtransparency="true" id="demo-iframe"></iframe>').addClass('show');
	$('.refresh-demo').toggleClass('active');
	$(".refresh-demo").click(function(){
		var iframe = document.getElementById('demo-iframe');
		iframe.src = iframe.src;
	});
});

$('.full-screen').on('click', function () {
	$('.single__slot-game').toggleClass('full-screen-iframe');
	$('body').toggleClass('overflow-hidden');

});

if ($('#toc_container').length > 0) {

	$('.ctoc-toggle').click(function () {
		$('#toc_container').toggleClass('active');
	});

	var anchors = document.querySelectorAll('.ctoc__item');
	var supportsNativeSmoothScroll = 'scrollBehavior' in document.documentElement.style;
	if (anchors.length && supportsNativeSmoothScroll) {
		Object.keys(anchors).forEach(function (anchor) {
			anchors[anchor].addEventListener('click', function (e) {
				e.preventDefault();
				var blockID, element, yCoordinate, yOffset;
				blockID = anchors[anchor].getAttribute('href').substr(1);
				element = document.getElementById(blockID);
				if (element) {
					yCoordinate = element.getBoundingClientRect().top + window.pageYOffset;
					yOffset = -90;
					window.scrollTo({
						top: yCoordinate + yOffset,
						behavior: 'smooth'
					});
				}

			})
		});
	}
}


function load_more(){
	$('.load-more').click(function(){
		var This = $(this),
			currentPage = This.attr('data-current'),
			vars = This.attr('data-vars'),
			maxPages = This.attr('data-max');
		var data = {
			'action': 'loadmore_all', //loadmore_all
			'page': currentPage,
			'query': vars
		};
		$.ajax({
			type : 'POST',
			url : ajaxactionurl,
			data: data,
			success: function(filtred){
				currentPage++;
				if(currentPage === maxPages){
					This.remove();
				}else{
					This.attr('data-current',currentPage);
				}
				$('.slot-list').append(filtred); //Указывае куда вернуть данные
				$('.slot-list img.lazy').lazyload({
					threshold: 10,
					effect : "fadeIn",
					failure_limit : 100
				});

			},
		});
	});
}
load_more();
